import { atom } from "jotai";
import { SetStateAction } from "jotai/core/types";

import { FKCService, UserData } from "./fkc.service";
import {
  FallbackPages,
  FKCPages,
  Pages,
  TermsAndPrivacyResponse,
} from "./fkc.types";

export const pagesAtom = atom<FKCPages>(Pages.OPTIN);

export const progressAtom = atom<number, SetStateAction<number>>(
  (get) => {
    const page = get(pagesAtom);

    if (Object.values(FallbackPages).includes(page as FallbackPages)) {
      // eslint-disable-next-line sonarjs/prefer-immediate-return -- keep the return statement because TS cannot infer type
      const prevPageProgress = get(progressAtom) as number;
      return prevPageProgress;
    }

    const pagesLength = Object.keys(Pages).length;
    const valueIndex = Object.values(Pages).indexOf(page as Pages);

    return Math.floor((valueIndex / pagesLength) * 100);
  },
  (get, set, update) => {
    const newValue =
      typeof update === "function" ? update(get(progressAtom)) : update;
    set(progressAtom, newValue);
  }
);

export const termsAndPrivacyAtom = atom<TermsAndPrivacyResponse>(async () =>
  FKCService.getTermsAndPrivacy()
);

export const linkedCardsAtom = atom<number | null>(null);

export const userDataAtom = atom<
  UserData | null,
  SetStateAction<UserData | null>
>(
  async () =>
    FKCService.getUser(
      window.theme.Sweepstake.prototype.retrieveSubmission()?.data?.email
    ).then((data) => data),
  (get, set, update) => {
    const newValue =
      typeof update === "function" ? update(get(userDataAtom)) : update;
    set(userDataAtom, newValue);
  }
);
